<template>

  <div class="card">
    <div class="row">
      <div class="col-md-10">
        <h5>
          Cuenta Bancaria
          <span class="badge badge-success" style="width:auto!important"
            v-if="supplier.verified === BankAccountStatus.VERIFIED">Verificada</span>
          <span class="badge badge-danger" style="width:auto!important" v-else>No Verificada</span>
        </h5>
      </div>
      <div class="col-md-2">
        <button class="btn btn-primary btn-raised" type="button" v-on:click="showVerificar()"
          v-if="is_treasury">Verificar</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label for="tradename">Nombre</label>
        <input type="text" class="form-control" v-model="supplier.name" :disabled="!is_treasury">
      </div>
      <div class="col-md-3">
        <label for="tradename">RFC</label>
        <input type="text" class="form-control" v-model="supplier.rfc" :disabled="!is_treasury">
      </div>
      <div class="col-md-6">
        <label v-if="supplier.account_file === ''">No se ha subido el Encabezado de estado de cuenta</label>
        <label v-else>
          Encabezado de estado de cuenta
          <a-secure :href="StorageURL + '/storage/private/user/' + usuario + '/' + supplier.account_file"
            target="_blank" download>
            <em class="material-icons">file_download</em>
          </a-secure>
          <a-secure :href="StorageURL + '/storage/private/user/' + usuario + '/' + supplier.account_file"
            target="_blank">
            <em class="material-icons">open_in_new</em>
          </a-secure>
        </label>
        <formdata-file-upload :popup="true" field="account_file" title="Estado de cuenta"
          :path="'/storage/private/user/' + usuario + '/'" :src="supplier.account_file" :userId="usuario"
          @uploaded="function (a) { supplier.account_file = a }"
          v-if="is_treasury && supplier.account_file !== ''"></formdata-file-upload>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label for="tradename">CLABE</label>
        <input type="text" class="form-control" v-model="supplier.clabe" :disabled="!is_treasury">
      </div>
      <div class="col-md-3">
        <label for="tradename">Banco</label>
        <input type="text" class="form-control" v-model="supplier.bank" :disabled="!is_treasury">
      </div>
    </div>
    <br>

    <!-- MODAL CONFIRMAR VERIFICACION CUENTA PROVEEDOR -->
    <div class="modal fade" ref="verificar" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Verificar Cuenta Bancaria de {{ supplier.name }}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-2 text-center"></div>
              <div class="col-md-8 text-center" style="margin-bottom: 15px;">
                <h6 style="margin-top: -10px;margin-bottom: 20px;">¿La CLABE, el RFC y el Nombre o la Razón Social del
                  proveedor corresponden con el Estado de Cuenta?</h6>
                <button class="btn btn-primary btn-raised" type="button" @click="verify" style="margin-right: 25px;"
                  data-dismiss="modal">Confirmar</button>
                <button class="btn btn-danger btn-raised" type="button" data-dismiss="modal">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import ASecure from "@components/utils/aSecure";
let FormDataFileUpload = require('../formdata-file-upload').default;
import { is } from '../functions/userRoleBehavior'
import { BankAccountStatus } from "@/models/BankAccountStatus";
import Vue from "vue";
export default {
  name: 'supplier-bank-vue',
  props: ['id_supplier', 'usuario', 'user_roles'],
  components: {
    ASecure,
    'formdata-file-upload': FormDataFileUpload,
  },
  mounted() {
    axios.get('/api/supplier/bank/' + this.id_supplier).then(response => {
      this.supplier = response.data;
    }).catch(() => {
      Vue.toasted.show('Error al cargar los datos bancarios', { position: 'bottom-center', type: 'error' });
      this.supplier = { name: '', rfc: '', clabe: '', bank: '', account_file: '', verified: BankAccountStatus.UNVERIFIED };
    });
  },
  data() {
    return {
      supplier: {}
    }
  },
  methods: {
    verify() {
      Vue.toasted.show('Verificando...', { position: 'bottom-center', closeOnSwipe: false });
      axios.post('/api/supplier/bank/verify/' + this.usuario).then(response => {
        Vue.toasted.clear();
        Vue.toasted.show('¡Cuenta verificada!', { position: 'bottom-center', type: 'success', closeOnSwipe: false, duration: 2000 });
        this.supplier.verified = BankAccountStatus.VERIFIED;
      }).catch(e => {
        Vue.toasted.clear();
        Vue.toasted.show('Parece que ha ocurrido un error, inténtalo de nuevo', { position: 'bottom-center', type: 'error', closeOnSwipe: true });
      });
    },
    isPDF(filename) {
      if (filename != null) {
        var datas = filename.split('.')
        var data = datas[datas.length - 1]
        if (data.toUpperCase() == 'PDF') {
          return true
        } else {
          return false
        }
      }
    },
    showVerificar() {
      let element = this.$refs.verificar;
      $(element).modal('show');
    }

  },
  computed: {
    BankAccountStatus() {
      return BankAccountStatus
    },
    is_treasury() {
      return is('treasury', this.user_roles)
    }
  }
}
</script>

<style scoped lang="scss">
.supplier-bank-vue {}

.row {
  margin-top: 15px;
}

.card {
  padding: 0 10px;
}

.file {
  min-height: 300px;
  max-height: 300px;
  overflow: hidden;
}

.file:hover {
  overflow: auto;
}

.file img {
  width: 100%
}
</style>
